const config = {
    build_number: '602484',
    build_timestamp: '2025-06-16T22:20:45.354Z',
    build_commit: '244ba87077fe15f9781f3e5644c36eb21deecda2',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
